import { render } from "./ProtectedContent.vue?vue&type=template&id=9283d34c"
import script from "./ProtectedContent.vue?vue&type=script&lang=js"
export * from "./ProtectedContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__